import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const CRM = lazy(() => import('./CRM'));

const TabLoader = () => (
  <div className="flex items-center justify-center h-full bg-background">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

const Index = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Sales Platform</title>
        <meta name="description" content="AI-powered sales platform" />
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col">
        <main className="flex-1 overflow-hidden">
          <Suspense fallback={<TabLoader />}>
            <CRM />
          </Suspense>
        </main>
      </div>
    </>
  );
};

export default Index;
